module.exports = __webpack_public_path__ + "img/header-mobile.179fef58.png";